module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAABGklEQVQ4jZ3SK0sEYRTG8b/ugEG2CJaTxDBBEEHMCoJgMAjajCbbegnGAcN6CfsRBMEoJkEE/RxusD4aTaKCqxx8F2bn4o7zxOH85hzOe0aSJCEbSevAFrAMvAB3wKmZPadLRwvgGXANbAITwAzQArqS5kqxpA3gIDfKb5rAg6SorHO7BPbjk2znsKRxYGoI9iwVdf4GehXwVw6b2ZsvpQK+Lers2RsCn8zsshCb2f0fP3gEFtMfomyFmXUkXQA74Y3fgRszu8rWDmBJs8AaMAmMhSU2vKOkVR/bD8jMugM4XFbZgaTTlnRoZidRgJ1wglVzLKnXiON4Hjj/B+xnxbe9XwN6Ph0v1MQfjqdr4qYv7AjYDU9SPfD6AxedTwUApPVQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/imgs/icon/icon_member.png
// module id = BVoS
// module chunks = 41